const container=[{initial:"empty record"}]
const timeTable=(state=container,action)=>{

// console.log("payload 2",action.payload)
  switch(action.type){

 case'TIMETABLE':
 return {record:action.payload}

 default:
   return state;

  }
}


export default timeTable;